const EMAILJS_ENDPOINT = "https://api.emailjs.com/api/v1.0/email/send";
const CONTACT_EMAIL = process.env.REACT_APP_CONTACT_EMAIL || "nurlannurka245@gmail.com";

const emailConfig = {
  serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID,
  templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
  publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
};

function hasRealValue(value) {
  return Boolean(value && !/x{4,}|service_x+|template_x+|g-x+/i.test(value));
}

export function isContactEmailConfigured() {
  return hasRealValue(emailConfig.serviceId) && hasRealValue(emailConfig.templateId) && hasRealValue(emailConfig.publicKey);
}

export function createMailtoLink({ name, email, message }) {
  const subject = encodeURIComponent(`Portfolio contact: ${name}`);
  const body = encodeURIComponent(`Name: ${name}\nEmail: ${email}\n\nMessage:\n${message}`);
  return `mailto:${CONTACT_EMAIL}?subject=${subject}&body=${body}`;
}

export async function sendContactMessage({ name, email, message }) {
  if (!isContactEmailConfigured()) {
    throw new Error("EMAIL_CONFIG_MISSING");
  }

  const response = await fetch(EMAILJS_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      service_id: emailConfig.serviceId,
      template_id: emailConfig.templateId,
      user_id: emailConfig.publicKey,
      template_params: {
        to_email: CONTACT_EMAIL,
        from_name: name,
        from_email: email,
        reply_to: email,
        message,
      },
    }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || "EMAIL_SEND_FAILED");
  }
}
